module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "generatorForm",
    attrs: {
      "model": _vm.report,
      "rules": _vm.rules,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Report Type",
      "prop": "type"
    }
  }, [_c('el-select', {
    staticClass: "full-width",
    model: {
      value: (_vm.report.type),
      callback: function($$v) {
        _vm.$set(_vm.report, "type", $$v)
      },
      expression: "report.type"
    }
  }, _vm._l((_vm.reportTypes), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.report.type === 'CAMPAIGN') ? _c('el-form-item', {
    attrs: {
      "label": "Campaign",
      "prop": "id"
    }
  }, [_c('el-select', {
    staticClass: "full-width",
    attrs: {
      "clearable": true,
      "filterable": true
    },
    model: {
      value: (_vm.report.id),
      callback: function($$v) {
        _vm.$set(_vm.report, "id", $$v)
      },
      expression: "report.id"
    }
  }, _vm._l((_vm.campaigns), function(campaign) {
    return _c('el-option', {
      key: campaign.id,
      attrs: {
        "label": campaign.title,
        "value": campaign.id
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.report.type === 'SURVEY') ? _c('el-form-item', {
    attrs: {
      "label": "Survey",
      "prop": "id"
    }
  }, [_c('el-select', {
    staticClass: "full-width",
    model: {
      value: (_vm.report.id),
      callback: function($$v) {
        _vm.$set(_vm.report, "id", $$v)
      },
      expression: "report.id"
    }
  }, _vm._l((_vm.surveys), function(survey) {
    return _c('el-option', {
      key: survey.id,
      attrs: {
        "label": survey.title,
        "value": survey.id
      }
    })
  }), 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer clearfix",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('span', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "id": "cancel",
      "type": "danger",
      "plain": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "id": "save",
      "type": "primary",
      "loading": _vm.loading,
      "plain": ""
    },
    on: {
      "click": _vm.generate
    }
  }, [(!_vm.loading) ? _c('span', [_vm._v("Generate")]) : _c('span', [_vm._v("Generating")])])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7107d4b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/automatedemails/recipients/GenerateReport.vue
// module id = 3332
// module chunks = 3